import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AttachEquipmentToCargo } from "dora-contracts";

/**
 * Equipment picked in the order dialog while creating a new cargo, before the
 * cargo exists on the server. Sent with the create request, which attaches it
 * in the same transaction. Like the draft invoice lines, it is ephemeral:
 * cleared when the create dialog opens and once the create has been sent.
 */
interface DraftCargoEquipmentState {
  picks: AttachEquipmentToCargo[];
}

const initialState: DraftCargoEquipmentState = {
  picks: [],
};

const slice = createSlice({
  name: "data/draft-cargo-equipment",
  initialState,
  reducers: {
    draftEquipmentSet: (
      state,
      action: PayloadAction<AttachEquipmentToCargo[]>
    ) => {
      state.picks = action.payload;
    },
    draftEquipmentQuantitySet: (
      state,
      action: PayloadAction<{ equipmentId: string; quantity: number }>
    ) => {
      const pick = state.picks.find(
        (p) => p.equipmentId === action.payload.equipmentId
      );
      if (pick) {
        pick.quantity = action.payload.quantity;
      }
    },
    draftEquipmentCleared: (state) => {
      state.picks = [];
    },
  },
});

export default slice.reducer;
export const {
  draftEquipmentSet,
  draftEquipmentQuantitySet,
  draftEquipmentCleared,
} = slice.actions;
